export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref5494.12879505.jpg";